import { getComponentEventActionCallbacks } from './componentEventActionEmitter';
function iEmitComponentEvent(_a) {
    var data = _a.data, payload = _a.payload, target = _a.target;
    var actionName = data.actionName;
    var callbacks = getComponentEventActionCallbacks(target.key, actionName);
    if (callbacks) {
        return Promise.all(callbacks.map(function (callback) { return Promise.resolve(callback({ data: data, payload: payload })); }));
    }
    return Promise.resolve();
}
export var emitComponentEvent = iEmitComponentEvent;
export var emitComponentEventAction = {
    id: Number.MAX_SAFE_INTEGER,
    name: 'emitComponentEventAction',
};
export function isEmitComponentEventActionId(id) {
    return id === emitComponentEventAction.id;
}
//# sourceMappingURL=emitComponentEvent.js.map